var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex h-100 flex-column",attrs:{"id":"app"}},[_c('EmotivaHeader'),_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"h-100"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }